export const generateRemoveOrderItemLoadingId = (orderId: string) => `remove-${orderId}`

export const generateAddToCartLoadingId = (
  companyId: string | undefined,
  reportCode: string,
  mode: 'addToCart' | 'buyNow'
) => `${mode}${companyId ? `-${companyId}` : ''}-${reportCode}`
